<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">DHR</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <select class="form-control" v-model="tab">
                            <option>A. DHR RIngkas</option>
                            <option>B. Laporan Data OP Ringkas</option>
                            <option>C. Laporan DHR Urut NOP</option>
                            <option>D. Laporan DHR Urut No. Formulir</option>
                            <option>E. Laporan DHR Urut Nama</option>
                            <option>F. Rekap Objek Pajak</option>
                            <option>G. Laporan Perubahan Data OP</option>
                            <option>I. Laporan Sejarah OP</option>
                            <option>K. Laporan Rekapitulasi OP Per Desa/Kelurahan</option>
                            <option>L. Laporan NOP Tidak Boleh Digunakan</option>
                            <option>N. Laporan Daftar Formulir Transaksi</option>
                            <option>O. Laporan Ringkas Pelengkap Peta Blok</option>
                        </select>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div v-if ="tab == 'A. DHR RIngkas'">
                    <h3>A. DHR Ringkas</h3>
                    <bhumie_dhr_tab1></bhumie_dhr_tab1>
                </div>
                <div v-if ="tab == 'B. Laporan Data OP Ringkas'">
                    <h3>B. Laporan Data OP Ringkas</h3>
                    <bhumie_dhr_tab2></bhumie_dhr_tab2>
                </div>
                <div v-if ="tab == 'C. Laporan DHR Urut NOP'">
                    <h3>C. Laporan DHR Urut NOP</h3>
                    <bhumie_dhr_tab3></bhumie_dhr_tab3>
                </div>
                <div v-if ="tab == 'D. Laporan DHR Urut No. Formulir'">
                    <h3>D. Laporan DHR Urut No. Formulir</h3>
                    <bhumie_dhr_tab4></bhumie_dhr_tab4>
                </div>
                <div v-if ="tab == 'E. Laporan DHR Urut Nama'">
                    <h3>E. Laporan DHR Urut Nama</h3>
                    <bhumie_dhr_tab5></bhumie_dhr_tab5>
                </div>
                <div v-if ="tab == 'F. Rekap Objek Pajak'">
                    <h3>F. Rekap Objek Pajak</h3>
                    <bhumie_dhr_tab6></bhumie_dhr_tab6>
                </div>
                <div v-if ="tab == 'G. Laporan Perubahan Data OP'">
                    <h3>G. Laporan Perubahan Data OP</h3>
                    <bhumie_dhr_tab7></bhumie_dhr_tab7>
                </div>
                <div v-if ="tab == 'I. Laporan Sejarah OP'">
                    <h3>Laporan Sejarah OP</h3>
                    <bhumie_dhr_tab8></bhumie_dhr_tab8>
                </div>
                <div v-if ="tab == 'K. Laporan Rekapitulasi OP Per Desa/Kelurahan'">
                    <h3>K. Laporan Rekapitulasi OP Per Desa/Kelurahan</h3>
                    <bhumie_dhr_tab9></bhumie_dhr_tab9>
                </div>
                <div v-if ="tab == 'L. Laporan NOP Tidak Boleh Digunakan'">
                    <h3>L. LAporan NOP Tidak Boleh Digunakan</h3>
                    <bhumie_dhr_tab10></bhumie_dhr_tab10>
                </div>
                <div v-if ="tab == 'N. Laporan Daftar Formulir Transaksi'">
                    <h3>N. Laporan Daftar Formulir Transaksi</h3>
                    <bhumie_dhr_tab11></bhumie_dhr_tab11>
                </div>
                <div v-if ="tab == 'O. Laporan Ringkas Pelengkap Peta Blok'">
                    <h3>O. Laporan Ringkas Pelengkap Peta Blok</h3>
                    <bhumie_dhr_tab12></bhumie_dhr_tab12>
                </div>
                

        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>

const ADD_URL = URL_APP+'api/v1/kecamatan/';


export default {
  name: "monev_kabupaten",
  data() {
    return {
        tab: 'A. DHR RIngkas',
    };
  },

// =============================================================== METHODS =========================================================================
  methods : {


  },
// =============================================================== METHODS =========================================================================

  mounted() {
    localStorage.sidemenu = 'bhumie';
  },
};
</script>
